export const CHARACTER_EMOTIONS = {
    NEUTRAL: 'neutral',
    THINKING: 'thinking',
};
